import { create } from "zustand";

export interface InstitutionListState {
  /** 1-based page. */
  page: number;
  searchQuery: string;
  /** "" = All; otherwise a status value such as "active" | "inactive". */
  status: string;
  /** "" = All tenants; otherwise a tenant id (platform admins only). */
  tenantId: string;
  setPage: (page: number) => void;
  /** Also resets the page to 1. */
  setSearchQuery: (query: string) => void;
  /** Also resets the page to 1. */
  setStatus: (status: string) => void;
  /** Also resets the page to 1. */
  setTenantId: (tenantId: string) => void;
  reset: () => void;
}

const initialState = { page: 1, searchQuery: "", status: "", tenantId: "" };

export const useInstitutionListStore = create<InstitutionListState>((set) => ({
  ...initialState,
  setPage: (page) => set({ page }),
  setSearchQuery: (searchQuery) => set({ searchQuery, page: 1 }),
  setStatus: (status) => set({ status, page: 1 }),
  setTenantId: (tenantId) => set({ tenantId, page: 1 }),
  reset: () => set({ ...initialState }),
}));
